let estimates = 0;
setInterval(() => {
    if (estimates > 1000) {
        console.log(`set ${estimates} keys in redis last 10000ms`);
    }
    estimates = 0;
}, 10000);
export const logByteEstimate = (key, s) => {
    estimates += 1;
    const n = typeof s === 'string' ? s.length : s;
    if (n > 1000000) {
        const estimate = n * 1.5;
        console.log(`redis set size: ${key} | size: ~${estimate / 1024}kb`);
    }
};
//# sourceMappingURL=tmp.js.map